export default "__VITE_ASSET__DFNnHCHO__"